<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->
          <el-button type="primary" class="btn primary" @click="toPay">生成付款单</el-button>
          <!--v-if="tableAcl.indexOf('ToPay') != -1"  -->
          <el-button type="primary" class="btn primary" @click="showBatchApproveDialog">批量审批</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="登记流水号" width="150">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="220" prop="supplierName" label="供应商"></el-table-column>
        <!-- <el-table-column width="80" prop="categoryNames" label="业务类型"></el-table-column> -->
        <el-table-column width="95" :show-overflow-tooltip="true" prop="billNo" label="发票号码"></el-table-column>
        <el-table-column width="110" prop="invoiceAmount" label="发票金额"></el-table-column>
        <el-table-column width="145" prop="totalAmount" label="匹配合计金额"></el-table-column>
        <el-table-column width="185" :show-overflow-tooltip="true" prop="redAmount" label="红冲金额">
          <template slot-scope="scope">
            <p style="color: red">
              红票 :{{ scope.row.redCode }}<br />
              金额:{{ scope.row.redAmount }}
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="redCode" label="红冲编号"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="receivedAmount" label="已付金额"></el-table-column>
        <el-table-column width="120" prop="date" label="发票日期">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.date), "{y}-{m}-{d}")
            }}</template>
        </el-table-column>
         <el-table-column prop="stateName" label="状态"></el-table-column>
        <el-table-column prop="typeName" label="随货发票"></el-table-column>
        <el-table-column prop="registerWayName" label="登记方式"></el-table-column>
        <el-table-column prop="createdUserName" label="登记人">
          <template slot-scope="scope">
            <span v-show="scope.row.registerWay == 0">{{ scope.row.createdUserName?scope.row.createdUserName:'-' }}</span>
            <span v-show="scope.row.registerWay == 1">{{ scope.row.registerUserName?scope.row.registerUserName:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="220" :show-overflow-tooltip="true" prop="remark" label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="110" prop="sourceCreatedTime" label="登记时间">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.sourceCreatedTime))
            }}</template>
        </el-table-column>
 
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center"
          prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
              @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="
              scope.row.status == 1 &&
              scope.row.state != 4 &&
              isShowApproveButton(scope.row.approverIds)
            " type="text" v-preventReClick @click="handleApprove(scope.row)"
              class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
              scope.row.state == 0 &&
              scope.row.status != 1 &&
              scope.row.status != 2 &&
              tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)"
              class="margin-left20 color-blue">编辑</el-button>

            <el-button v-if="showDeleteBtn(scope.row)" type="text" v-preventReClick @click="handleDelete(scope.row)"
              class="margin-left20 color-blue">删除</el-button>

            <el-button v-if="showCancelBtn(scope.row)" type="text" v-preventReClick @click="handleCancel(scope.row)"
              class="margin-left20 color-blue">作废</el-button>
            <el-button type="text" class="margin-left20 color-blue"
              v-if="tableAcl.indexOf('Copy') != -1 && scope.row.state == 4"
              @click="handleCopy(scope.row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <el-dialog title="批量审批" :visible.sync="batchApproveDialogDisable" width="40%" :close-on-click-modal="false">
      <ApproveInfo ref="approveInfo" :reasonSpanVal="24" @change="batchApproveResultChange"></ApproveInfo>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="batchApproveDialogDisable = false">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="batchApprove">确
          定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetInvoiceRegisters,
  RemoveInvoiceRegisters,
  CancelInvoiceRegister,
  ApproveInvoiceRegisters,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  InvoiceRegisterOptions,
  RegisterWayOptions,
  StockCategoryOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import ApproveInfo from "@/components/approve-info";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    ApproveInfo,
  },
  data() {
    return {
      GetDatasAction: GetInvoiceRegisters,
      RemoveAction: RemoveInvoiceRegisters,
      cancelAction: CancelInvoiceRegister,
      editPath: "invoice-register-edit",

      InvoiceRegisterOptions: InvoiceRegisterOptions,
      RegisterWayOptions: RegisterWayOptions,
      StockCategoryOptions: StockCategoryOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "登记流水号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "发票号码",
          type: "input",
          code: "billNo",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "发票日期",
          type: "date",
          code: "date",
        },
        {
          name: "登记日期",
          type: "date",
          code: "createdTime",
        },
        {
          name: "金额范围",
          type: "numberRange",
          startCode: "startAmount",
          endCode: "endAmount",
        },
        {
          name: "状态",
          type: "select",
          code: "states",
          multiple: true,
          data: InvoiceRegisterOptions,
        },
        {
          name: "登记方式",
          type: "select",
          code: "registerWay",
          data: RegisterWayOptions,
        },
        // {
        //   name: "业务类型",
        //   type: "select",
        //   code: "category",
        //   data: StockCategoryOptions,
        // },
        {
          name: "入库单号",
          type: "input",
          code: "purchaseInStockNo",
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
      ],
      batchApproveDialogDisable: false,
      batchApproveForm: {
        ids: [],
        state: 1,
        approveRemark: "",
      },
    };
  },
  methods: {
    handleCopy(row) {
      this.$router.push("/invoice-register-edit?formMode=2&isCopy=1&id=" + row.id);
    },
    toPay() {
      const length = this.ids.length;
      if (length === 0) {
        this.$my_message(`请选择数据`, "warning");
        return;
      }
      let statusDatas = this.multipleSelection.filter((e) => e.status != 2);
      if (statusDatas != null && statusDatas.length > 0) {
        this.$my_message(`存在不是生效状态的发票登记单，不能生成付款单`, "warning");
        return;
      }
      let stateDatas = this.multipleSelection.filter((e) => e.state != 1 && e.state != 2);
      if (stateDatas != null && stateDatas.length > 0) {
        this.$my_message(`只能选择已验证或付款中的发票`, "warning");
        return;
      }
      let supplierArr = this.multipleSelection.filter(
        (item) => item.supplierId != this.multipleSelection[0].supplierId
      );
      if (supplierArr && supplierArr.length > 0) {
        this.$my_message("只能选择同一个供应商的发票进行付款", "warning");
        return;
      }
      this.supplierId = this.multipleSelection[0].supplierId;
      this.supplierName = this.multipleSelection[0].supplierName;
      const h = this.$createElement;
      let content = [h("p", "确定要生成付款单吗？")];

      this.$confirm("提示", {
        title: "提示",
        type: "warning",
        message: h("div", content),
      }).then(() => {
        this.$router.push({
          name: "PaymentApplyEdit",
          params: {
            supplierId: this.supplierId,
            supplierName: this.supplierName,
            registerArray: this.multipleSelection,
          },
        });
      });
    },
    handleDelete(row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return this.RemoveAction({
            ids,
          });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },

    handleCancel(row) {
      this.$my_confirm("此操作将作废此条数据数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return this.cancelAction({
            id: row.id,
          });
        })
        .then((res) => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        });
    },
    showDeleteBtn(row) {
      // 手工登记+未验证+草稿      手工登记+未验证+未通过   手工登记+未验证 tableAcl.indexOf('Remove') != -1 && (scope.row.state==0 && scope.row.registerWay==0 )
      if (
        this.tableAcl.indexOf("Remove") != -1 &&
        row.state == 0 &&
        row.registerWay == 0 &&
        (row.status == -1 || row.status == 0)
      ) {
        return true;
      }
      return false;
    },
    showCancelBtn(row) {
      // 流程状态未通过 scope.row.status ==0
      // 未验证并且 登记方式=自动同步 scope.row.state==0
      // 已验证的
      // 红字冲销的

      if (this.tableAcl.indexOf("Cancel") == -1 || row.status == 0) {
        //this.tableAcl.indexOf('Cancel') == -1 ||
        return false;
      }
      if ((row.state == 0 && row.registerWay == 1) || row.state == 1 || row.state == 5) {
        return true;
      }
      return false;
    },
    showBatchApproveDialog() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$my_message(`请先勾选要审批的数据`, "warning");
        return;
      }

      for (var i = 0; i < this.multipleSelection.length; i++) {
        // 数据状态
        if (this.multipleSelection[i].status != 1) {
          this.$my_message(`所选的数据中包含了不是待审批的数据，请检查`, "warning");
          return;
        }

        // 审批人
        let idArr = this.multipleSelection[i].approverIds.split(";");
        if (!idArr || idArr.indexOf(this.userInfo.id + "") == -1) {
          this.$my_message(`所选数据存在不需要您审批的单据，请检查`, "warning");
          return;
        }
      }

      this.batchApproveDialogDisable = true;
      this.batchApproveForm = {
        ids: this.ids,
        state: 1,
        approveRemark: "",
      };
    },
    batchApprove() {
      ApproveInvoiceRegisters(this.batchApproveForm).then((res) => {
        this.$my_message(`审批成功！`, "success");
        this.batchApproveDialogDisable = false;

        this.ids = [];
        this.multipleSelection = [];

        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
        this.getData();
      });
    },
    batchApproveResultChange(result, reason) {
      this.batchApproveForm.state = result;
      this.batchApproveForm.approveRemark = reason;
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped></style>
